import { createI18n } from 'vue-i18n'
import enCommon from './en-US/common.json'
import enAuth from './en-US/auth.json'
import enDashboard from './en-US/dashboard.json'
import enSecurity from './en-US/security.json'
import enPhase1 from './en-US/phase1.json'
import enPhase2 from './en-US/phase2.json'
import enPhase3 from './en-US/phase3.json'
import enSettings from './en-US/settings.json'
import esCommon from './es-US/common.json'
import esAuth from './es-US/auth.json'
import esDashboard from './es-US/dashboard.json'
import esSecurity from './es-US/security.json'
import esPhase1 from './es-US/phase1.json'
import esPhase2 from './es-US/phase2.json'
import esPhase3 from './es-US/phase3.json'
import esSettings from './es-US/settings.json'

export type RouteLocale = 'en' | 'es'
export type AppLocale = 'en-US' | 'es-US'

export const messages = {
  'en-US': {
    ...enCommon,
    ...enAuth,
    ...enDashboard,
    ...enSecurity,
    ...enPhase1,
    ...enPhase2,
    ...enPhase3,
    ...enSettings,
  },
  'es-US': {
    ...esCommon,
    ...esAuth,
    ...esDashboard,
    ...esSecurity,
    ...esPhase1,
    ...esPhase2,
    ...esPhase3,
    ...esSettings,
  },
} as const

export function appLocaleFor(routeLocale: string): AppLocale {
  return routeLocale === 'es' ? 'es-US' : 'en-US'
}

export function routeLocaleFor(appLocale: string): RouteLocale {
  return appLocale === 'es-US' ? 'es' : 'en'
}

export function detectRouteLocale(): RouteLocale {
  if (typeof document !== 'undefined') {
    const stored = document.cookie
      .split('; ')
      .find((entry) => entry.startsWith('pourla_locale='))
      ?.split('=')[1]
    if (stored === 'en' || stored === 'es') {
      return stored
    }
  }
  return typeof navigator !== 'undefined' && navigator.language.toLowerCase().startsWith('es')
    ? 'es'
    : 'en'
}

export function rememberRouteLocale(locale: RouteLocale): void {
  if (typeof document !== 'undefined') {
    document.cookie = `pourla_locale=${locale}; Path=/; Max-Age=31536000; SameSite=Lax`
    document.documentElement.lang = locale
  }
}

export const i18n = createI18n({
  legacy: false,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages,
})

export default i18n
